import { render, staticRenderFns } from "./resetPasswordSuccess.vue?vue&type=template&id=3a8d6f74&scoped=true&"
var script = {}
import style0 from "./resetPasswordSuccess.vue?vue&type=style&index=0&id=3a8d6f74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8d6f74",
  null
  
)

export default component.exports